import React, { lazy } from 'react';
import { createLogger, loadComponent } from '@cko/dashboard-shared';

import { Mfe, Team } from 'config/shared/enums/mfeTeam';
import { useHeap } from '../../hooks/useHeap';
import { KILLSWITCH_CONFIG } from '../../environment/killswitches';

const supportLogger = createLogger({
  context: {
    mfe: Mfe.CARE_CASE_MANAGEMENT,
    team: Team.MERCHANT_CARE,
  },
});
const SupportWidget = lazy(
  loadComponent(
    Mfe.CARE_CASE_MANAGEMENT,
    './SupportWidget',
    () => Promise.resolve({ default: () => null }),
    supportLogger,
  ),
);

const Heap = () => {
  useHeap();
  return null;
};

export const IntegrationsInjector = () => {
  return (
    <>
      {KILLSWITCH_CONFIG.heapDisabled ? null : <Heap />}
      {KILLSWITCH_CONFIG.supportDisabled ? null : <SupportWidget />}
    </>
  );
};
